import React from 'react';

interface FinanceDepositRangeProps {
  min: number;
  max: number;
  value: number;
  setValue: (value: number) => void;
  minLabel: string;
  maxLabel: string;
  disabled: boolean;
}

function FinanceDepositRange({
  min,
  max,
  value,
  setValue,
  minLabel,
  maxLabel,
  disabled
}: FinanceDepositRangeProps): React.ReactElement {
  const [changingValue, setChangingValue] = React.useState(value);
  const percentageOfRange = ((changingValue - min) * 100) / (max - min);

  React.useEffect(() => {
    setChangingValue(value);
  }, [value]);

  return (
    <div className={`finance-deposit-range ${disabled ? 'finance-deposit-range--disabled' : ''}`}>
      <span className="finance-deposit-range__label">{minLabel}</span>
      <div className="finance-deposit-range__wrapper">
        <div className="finance-deposit-range__value-wrapper">
          <span className="finance-deposit-range__value" style={{ left: `${Math.max(percentageOfRange, 0)}%` }}>
            £{Number.isInteger(changingValue) ? changingValue : changingValue.toFixed(2)}
          </span>
        </div>
        <input
          className="finance-deposit-range__input"
          onMouseUp={(): void => setValue(changingValue)}
          onTouchEnd={(): void => setValue(changingValue)}
          type="range"
          min={Math.ceil(min)}
          max={Math.floor(max)}
          step="1"
          onChange={(e): void => setChangingValue(Number(e.currentTarget.value))}
          disabled={disabled}
          value={changingValue}
        />
      </div>
      <span className="finance-deposit-range__label">{maxLabel}</span>
    </div>
  );
}

export default FinanceDepositRange;
